"use client";
import { Button, ButtonProps } from "@/components/ui/button";
import { useTranslation } from "@/hooks/translationContext";
import { usePlausible } from "next-plausible";
import {
  CLICK_QUOTE_EVENT_SECTIONS,
  PLAUSIBLE_GOAL_KEYS
} from "@/@core/constants/plausible";
import { useContactWithVenuesLink } from "@/hooks/useContactWithVenuesLink";
import { Link } from "@/components/CustomLink";
import { useIsAskQuestionEnabled } from "@/hooks/useIsAskQuestionEnabled";

interface Props extends ButtonProps {
  buttonClassName?: string;
  textClassName?: string;
}

export default function QuoteButton(props: Props) {
  const {
    variant,
    size,
    textClassName,
    buttonClassName = "flex items-center justify-center gap-2 px-4 py-2",
  } = props;
  const { t } = useTranslation();
  const plausible = usePlausible();
  const href = useContactWithVenuesLink();
  const isAskQuestionEnabled = useIsAskQuestionEnabled();

  const sendPlausibleEvent = () => {
    try {
      plausible(PLAUSIBLE_GOAL_KEYS.CLICK_QUOTE_EVENT, {
        props: {
          section: CLICK_QUOTE_EVENT_SECTIONS.LIST_PAGE_HEADER_SECTION,
        },
      });
    } catch (error) {
      console.error("Plausible event gönderiminde hata:", error);
    }
  };

  if (!isAskQuestionEnabled) return null;

  return (
    <Link
      onClick={() => sendPlausibleEvent()}
      aria-label={`${t("quote-button-title")}`}
      href={href}
    >
      <Button
        variant={variant}
        size={size}
        className={buttonClassName}
        aria-label={`${t("quote-button-title")}`}
      >
        <span className={textClassName}>{t("quote-button-title")}</span>
      </Button>
    </Link>
  );
}